import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import HR from 'UIComponents/elements/HR';
import { CardMenu, CardMenuFooterLink, CardMenuOptions } from '..';
import { CardMenuAddToPlaylistOption, CardMenuChangePlaylistThumbnailOption, CardMenuWatchLaterOption, CreatePlaylistLink, EditPlaylistButton, SavePlaylistButton, useUserOwnsPlaylist } from '../../savedItems';
import getLang from 'I18n/utils/getLang';
import { FormattedMessage } from '../../../components/I18n';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import StartPlaylistButton from '../../savedItems/components/StartPlaylistButton';
import styled from '../../../utils/Styling';
import UsageTracker from '../../../utils/UsageTracker';
import { OverviewSource } from '../../tracks';
import { ShareButton } from '../../share';
const CardStartPlaylistButton = styled(StartPlaylistButton).withConfig({
  displayName: "DesktopCardMenu__CardStartPlaylistButton",
  componentId: "zwhfxe-0"
})([".loading-spinner{position:relative !important;}"]);

const DesktopCardShareButton = shareButtonProps => /*#__PURE__*/_jsx(ShareButton, Object.assign({}, shareButtonProps, {
  render: button => /*#__PURE__*/_jsx(UISideNavItem, {
    role: "navigation-item",
    title: button
  })
}));

const trackCreateNewPlaylist = () => {
  UsageTracker.track('playlistInteraction', {
    action: 'add-to-new-playlist',
    location: 'card-menu'
  });
};

const trackAddToPlaylist = () => {
  UsageTracker.track('playlistInteraction', {
    action: 'add-to-playlist',
    location: 'card-menu'
  });
};

const TrackLessonMenuOptions = ({
  trackId,
  lessonId,
  language = getLang(),
  closeModal
}) => {
  const onCreateNewClick = () => {
    trackCreateNewPlaylist();
    closeModal();
  };

  const onAddToPlaylistClick = () => {
    trackAddToPlaylist();
    closeModal();
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CardMenuWatchLaterOption, {
      lessonId: lessonId,
      onClick: closeModal,
      trackId: trackId
    }), /*#__PURE__*/_jsx(CardMenuAddToPlaylistOption, {
      language: language,
      lessonId: lessonId,
      onCreatePlaylistClick: onCreateNewClick,
      onPlaylistClick: onAddToPlaylistClick,
      trackId: trackId
    }), /*#__PURE__*/_jsx(HR, {
      distance: "extra-small"
    }), /*#__PURE__*/_jsx(DesktopCardShareButton, {
      language: language,
      lessonId: lessonId,
      onClick: closeModal,
      trackId: trackId
    })]
  });
};

const TrackLessonMenuFooter = ({
  trackId,
  lessonId,
  language = getLang(),
  closeModal
}) => {
  const onCreateNewClick = () => {
    closeModal();
    trackCreateNewPlaylist();
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HR, {
      distance: "flush"
    }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
      language: language,
      lessonId: lessonId,
      render: (content, to) => /*#__PURE__*/_jsx(CardMenuFooterLink, {
        onClick: onCreateNewClick,
        to: to,
        children: content
      }),
      trackId: trackId,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.cardMenu.addToNewPlaylist"
      })
    })]
  });
};

const PlaylistMenuOptions = ({
  playlistId,
  closeModal,
  language = getLang()
}) => {
  const userIsOwner = useUserOwnsPlaylist(playlistId);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UISideNavItem, {
      linkComponent: "div",
      title: /*#__PURE__*/_jsx(CardStartPlaylistButton, {
        appearsIn: OverviewSource.Playlist,
        playlistId: playlistId,
        showLoader: true,
        style: {
          textDecoration: 'none',
          fontWeight: 'normal',
          width: '100%'
        },
        use: "unstyled"
      })
    }), userIsOwner && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UISideNavItem, {
        linkComponent: "div",
        role: "navigation-item",
        title: /*#__PURE__*/_jsx(EditPlaylistButton, {
          playlistId: playlistId,
          style: {
            fontWeight: 'normal',
            width: '100%',
            textDecoration: 'none'
          },
          use: "unstyled"
        })
      }), /*#__PURE__*/_jsx(CardMenuChangePlaylistThumbnailOption, {
        onItemClick: closeModal,
        playlistId: playlistId
      }), /*#__PURE__*/_jsx(HR, {
        distance: "extra-small"
      })]
    }), /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(DesktopCardShareButton, {
        onClick: closeModal,
        playlistId: playlistId
      }), /*#__PURE__*/_jsx(HR, {
        distance: "extra-small"
      })]
    }), /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(SavePlaylistButton, {
        language: language,
        onClick: closeModal,
        playlistId: playlistId,
        render: content => /*#__PURE__*/_jsx(UISideNavItem, {
          role: "navigation-item",
          title: content
        }),
        showTooltip: true,
        style: {
          width: '100%'
        }
      })
    })]
  });
};

const DesktopCardMenu = (_ref) => {
  let {
    children,
    placement = 'bottom right',
    onOpenChange,
    isOpen
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "placement", "onOpenChange", "isOpen"]);

  const handleOnOpenChange = e => onOpenChange(e.target.value);

  const closeModal = () => onOpenChange(false);

  const {
    playlistId
  } = props;
  return /*#__PURE__*/_jsx(CardMenu, {
    content: {
      body: /*#__PURE__*/_jsx(CardMenuOptions, {
        children: playlistId ? /*#__PURE__*/_jsx(PlaylistMenuOptions, {
          closeModal: closeModal,
          playlistId: playlistId
        }) : /*#__PURE__*/_jsx(TrackLessonMenuOptions, Object.assign({
          closeModal: closeModal
        }, props))
      }),
      footer: playlistId ? null : /*#__PURE__*/_jsx(TrackLessonMenuFooter, Object.assign({
        closeModal: closeModal
      }, props))
    },
    onOpenChange: handleOnOpenChange,
    open: isOpen,
    placement: placement,
    children: children
  });
};

export default DesktopCardMenu;